export default {
    observability: {
        expectedApiErrors: [],
        mutedApiErrors: []
    }
};

//# sourceMappingURL=defaultConfig.js.map